module.exports = __webpack_public_path__ + "img/logo-juancho.08836288.png";